import { queryOptions } from '@tanstack/react-query'

import * as hl from '@nktkas/hyperliquid'
import { isTestnet } from '@/config/consts'
import { SpotMeta } from '@nktkas/hyperliquid'

const transport = new hl.HttpTransport({ isTestnet })
const publicClient = new hl.PublicClient({ transport })

// export type HyperCoreAssets = Awaited<ReturnType<typeof publicClient.spotMeta>>['tokens']
import { SpotToken } from '@nktkas/hyperliquid'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import { Token } from '@/domain/types/Token'
export type HyperCoreAsset = Awaited<SpotToken & {
  systemAddress: string
}>

import { CheckedAddress } from '@/domain/types/CheckedAddress'
export const HYPE_TOKEN_ID = isTestnet ? '0x0d01dc56dcaaca66ad901c959b4011ec' : '0x0d01dc56dcaaca66ad901c959b4011ec'
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function hyperCoreAssetsQueryOptions() {
  return queryOptions<HyperCoreAsset[]>({ // Changed to array type since we're returning an array
    queryKey: hyperCoreAssetsQueryKey(),
    queryFn: async () => {
      try {
        const { tokens }: SpotMeta = await publicClient.spotMeta()

        return [...tokens.filter((token:any) => token?.evmContract !== null).map((token:any) => ({
          ...token,
          systemAddress: "0x2" + "0".repeat(39).substr(0, 39 - token.index.toString(16).length) + token.index.toString(16)
        })), {
          token: new Token({
            symbol: TokenSymbol('HYPE'),
            name: 'HYPE',
            decimals: 18,
            address: CheckedAddress(`0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE`),
            unitPriceUsd: '0',
          }),
          name: 'HYPE',
          szDecimals: 2,
          weiDecimals: 8,
          index: 0,
          tokenId: HYPE_TOKEN_ID,
          isCanonical: true,
          evmContract: {
            address: '0x' + '2'.repeat(40),
            evm_extra_wei_decimals: 18
          },
          systemAddress: '0x' + '2'.repeat(40)
        }]
      } catch (error) {
        console.error(error)
        return []
      }
    },
  })
}

export function hyperCoreAssetsQueryKey(): unknown[] {
  return ['hyper-core-assets']
}
